<div class="branch-settings page-shell">
  <mat-toolbar class="header">
    <span>{{ "branchSettings.header" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="addBranch()"
        [disabled]="isLoading"
      >
        <mat-icon>add</mat-icon>
        {{ "branchSettings.new" | translate }}
      </button>
    </div>
  </mat-toolbar>

  <div class="branch-settings-content">
    <div
      class="table-container"
      [class.table-container--empty]="!isLoading && dataSource.data.length === 0"
      [class.table-container--loading]="isLoading"
    >
      <table mat-table [dataSource]="dataSource" class="settings-table mat-elevation-z0">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ "branchSettings.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="employeesCount">
          <th mat-header-cell *matHeaderCellDef>
            {{ "branchSettings.employeesCount" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.employeeIds?.length || 0 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>
            {{ "branchSettings.createdAt" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.createdAt" class="date-time-container">
              <div>{{ element.createdAt | localizedDate : "mediumDate" }},</div>
              <div>{{ element.createdAt | localizedDate : "mediumTime" }}</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="modifiedAt">
          <th mat-header-cell *matHeaderCellDef>
            {{ "branchSettings.modifiedAt" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.modifiedAt" class="date-time-container">
              <div>{{ element.modifiedAt | localizedDate : "mediumDate" }},</div>
              <div>{{ element.modifiedAt | localizedDate : "mediumTime" }}</div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="table-actions">
              <button type="button" class="action-btn" (click)="editBranch(element); $event.stopPropagation()">
                <mat-icon>edit</mat-icon>
                {{ "edit" | translate }}
              </button>
              <button type="button" class="action-btn action-btn--danger" (click)="removeBranch(element.branchId); $event.stopPropagation()">
                <mat-icon>delete_outline</mat-icon>
                {{ "delete" | translate }}
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="table-row--clickable"
          (click)="editBranch(row)"
        ></tr>
      </table>

      <div class="loading-wrapper" *ngIf="isLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!isLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">apartment</mat-icon>
        <p>{{ "branchSettings.noBranches" | translate }}</p>
      </div>
    </div>
  </div>
</div>
